import { Link } from 'react-router-dom'
import { savedViewsApi, type SavedView } from '../../api/savedViews'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { WidgetBody } from './WidgetBody'

async function findView(id: number): Promise<SavedView | null> {
  const [contracts, leads] = await Promise.all([savedViewsApi.list('contracts'), savedViewsApi.list('leads')])
  return [...contracts.items, ...leads.items].find(v => v.id === id) ?? null
}

/** Una vista salvata: il nome, a chi è visibile e il collegamento alla pagina. Non duplica l'elenco. */
export function SavedViewWidget({ item }: WidgetProps) {
  const id = item.savedViewId ?? 0
  const state = useWidgetData(() => findView(id), String(id))
  return (
    <WidgetBody state={state}>
      {view =>
        view === null ? (
          <div className="text-muted md-typescale-body-small">La vista non esiste più o non è più visibile.</div>
        ) : (
          <>
            <div className="md-typescale-emphasized-body-medium">{view.name}</div>
            <div className="text-muted md-typescale-body-small mb-2">
              {view.pageKey === 'leads' ? 'Lead' : 'Pratiche'} · {view.visibility}
            </div>
            <Link to={view.pageKey === 'leads' ? '/leads' : '/contracts'} className="md-typescale-body-small">
              Apri la pagina
            </Link>
          </>
        )
      }
    </WidgetBody>
  )
}
